import { useCallback, useMemo } from "react";
import { useQuery } from "urql";

import { GetBaseModelMetadataList } from "./queries.graphql";

export const useBaseModelMetadata = () => {
  const [{ data }] = useQuery({
    query: GetBaseModelMetadataList,
  });

  const metadataById = useMemo(() => {
    if (!data?.baseModelMetadataList) return null;
    const map = new Map<string, string>();
    for (const entry of data.baseModelMetadataList) {
      map.set(entry.id, entry.inferenceTimingRange);
    }
    return map;
  }, [data?.baseModelMetadataList]);

  const getTimingRange = useCallback(
    (baseModelId: string | undefined | null): string | undefined => {
      if (!baseModelId || !metadataById) return undefined;
      return metadataById.get(baseModelId);
    },
    [metadataById],
  );

  return { getTimingRange };
};
